import { render, staticRenderFns } from "./product_registration_step_3.vue?vue&type=template&id=31b1ade6&scoped=true"
import script from "./product_registration_step_3.vue?vue&type=script&lang=js"
export * from "./product_registration_step_3.vue?vue&type=script&lang=js"
import style0 from "./product_registration_step_3.vue?vue&type=style&index=0&id=31b1ade6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b1ade6",
  null
  
)

export default component.exports